import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--space-300) var(--space-500);
  gap: var(--space-400);
  border-radius: var(--radius-brand);
  background: rgba(242, 83, 141, 0.15);

  ${mediaQueries.tablet} {
    flex-direction: row;
    align-items: center;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: var(--space-100);
`

export const Title = styled.h3`
  margin: 0;
  color: var(--text-primary);
  font-family: var(--font-family-heading);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-dense);
`

export const Description = styled.div`
  opacity: 0.6;
  color: var(--text-primary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);

  a {
    color: var(--text-primary);
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: auto;
    text-underline-offset: 25%;
    text-underline-position: from-font;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--space-250);
  width: 100%;

  ${mediaQueries.tablet} {
    width: auto;
  }

  button,
  a {
    flex: 1;
    min-width: 0;

    ${mediaQueries.tablet} {
      flex: initial;
      min-width: initial;
    }
  }
`
